import { render, staticRenderFns } from "./ClientPaymentsTable.vue?vue&type=template&id=789c577b&"
import script from "./ClientPaymentsTable.vue?vue&type=script&lang=js&"
export * from "./ClientPaymentsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports